import { render, staticRenderFns } from "./humanising.vue?vue&type=template&id=25d22552&scoped=true&lang=pug&"
import script from "./humanising.vue?vue&type=script&lang=js&"
export * from "./humanising.vue?vue&type=script&lang=js&"
import style0 from "./humanising.vue?vue&type=style&index=0&id=25d22552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d22552",
  null
  
)

/* custom blocks */
import block0 from "~/lang/humanising?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230601152131%2Fcomponents%2Fproducts%2Fhumanising.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230601152131/components/widgets/image.vue').default})
